import { useQuery } from '@pylot-data/hooks/use-query'
import { CUSTOMER_QUERY } from '@corratech/pylot-auth-manager/src/graphql/customerQuery'
import type { Customer } from '@pylot-data/fwrdschema'

export const hasToken = (): boolean => {
    if (typeof window !== 'object') {
        return false
    }
    return !!getToken()
}
export const getToken = (): string | null => {
    if (typeof window !== 'object') {
        return null
    }
    return window.localStorage.getItem('pylot_token')
}

export const useUserObservable = () => {
    const swrOptions = {
        revalidateOnFocus: false,
        revalidateOnMount: false,
        revalidateOnReconnect: false
    }
    const {
        data,
        error: requestError,
        isValidating
    } = useQuery<null, { customer: Customer }>(
        CUSTOMER_QUERY,
        // no variables for this query because identifier comes from the auth cookie or header (see PYLOT-101)
        null,
        swrOptions
    )

    const loading = isValidating && !data
    const isSignedIn = !requestError && !!data && !data.errors
    const customer = data?.data?.customer
    const error = requestError ?? data?.errors

    return {
        loading,
        error,
        isSignedIn,
        customer
    }
}
